import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { CalendarEventType, ExceptionCalendarEvent } from '../../../types';

interface Props {
  event: ExceptionCalendarEvent;
}
export const ExceptionEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'exception' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  // TODO: move it to common css
  background:
    'repeating-linear-gradient(135deg, rgb(244, 245, 247) 0px, rgb(244, 245, 247) 0.6rem, rgb(218, 222, 227) 0.6rem, rgb(218, 222, 227) 0.9rem) 0px 0px repeat fixed',
});
